/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */
import styles from './ErrorPage.module.scss';
import * as React from 'react';
const SUMMARY_MESSAGE = "We're sorry, something went wrong on our side.";

const DefaultErrorMessage = () => (
  <div className={styles['error-page-message']}>
    The current page didn't load correctly. Please try again later or &nbsp;
    <a
      className={styles['error-page-link']}
      href="javascript:window.location.reload(true)">
      try reloading the page.
    </a>
  </div>
);

const ErrorPage = ({ children, summaryMessage = SUMMARY_MESSAGE }) => (
  <div className={styles['error-page-container']}>
    <div className={styles['error-page-content']}>
      <div className={styles['error-page-icon']}>
        <img
          src={require('../../../assets/images/error-message.svg')}
          alt="error message"
        />
      </div>
      <div className={styles['error-page-title']}>{summaryMessage}</div>
      {children || <DefaultErrorMessage />}
    </div>
  </div>
);

export default ErrorPage;
